const isString = (string: any): string is string => typeof string === 'string';

export default isString;
